import { createFileRoute } from '@tanstack/react-router';

import { BookSessionScreen } from '@/features/sessions/components/workspace/BookSessionScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/sessions/book')({
  beforeLoad: () => {
    requirePermission('session:create');
  },
  component: ClinicalBookSessionRoute,
  staticData: { crumb: 'Book session' },
});

function ClinicalBookSessionRoute() {
  return <BookSessionScreen surface="clinical" />;
}
